import userService from '../../services/ClassenService/modules/userService';

const state = {
  authUser: null,
  users: [],
};

const mutations = {
  SET_USER(state, userObj) {
    state.authUser = userObj;
    userService.setToken(userObj.access_token);
    userService.setLanguage(userObj.languageId);
  },

  SET_USERS(state, users) {
    state.users = users;
  },

  CLEAR_USER(state) {
    state.authUser = null;
  },

  CLEAR_USERS(state) {
    state.users = [];
  }
};

const getters = {
  getActiveUser: (state) => () => state.authUser,
  getUsers() {
    return state.users
  }
};

const actions = {
  getUsers: (context) => {
    if (context.state.users.length === 0) {
      context.commit('SET_USERS', ["loading"]);
      userService.getUsers().then((response) => {
        context.commit('SET_USERS', response.data)
      });
    }
    return context.state.users
  },

  reloadUsers: (context) => {
    userService.getUsers().then((response) => {
      context.commit('SET_USERS', response.data)
    });

    return context.state.users
  },

  getUser: ({commit}, userId) => new Promise((resolve, reject) => {
    userService.getUser(userId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateUser: ({commit}, {userId, userData}) => new Promise((resolve, reject) => {
    userService.updateUser(userId, userData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  changePassword: ({commit}, userData) => new Promise((resolve, reject) => {
    userService.changePassword(userData.userId, userData)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  }),

  updateOwnUser: ({commit}, userData) => new Promise((resolve, reject) => {
    userService.updateOwnUser(userData.userId, userData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteUser: ({commit}, data) => new Promise((resolve, reject) => {
    userService.deleteUser(data.userId, data.changeToId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addUser: ({commit}, userData) => new Promise((resolve, reject) => {
    userService.addUser(userData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getNewUsers: ({commit}) => new Promise((resolve, reject) => {
    userService.getNewUsers()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getNewUser: ({commit}, token) => new Promise((resolve, reject) => {
    userService.getNewUsers(token)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addNewUser: ({commit}, newUserData) => new Promise((resolve, reject) => {
    userService.addNewUser(newUserData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateNewUser: ({commit}, newUserToken, newUserData) => new Promise((resolve, reject) => {
    userService.updateNewUser(newUserToken, newUserData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteNewUser: ({commit}, newUserToken) => new Promise((resolve, reject) => {
    userService.deleteNewUser(newUserToken)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  loginUser: (context, userCredentials) => {
    const userObject = {
      grant_type: 'password',
      username: userCredentials.email,
      password: userCredentials.password,
      scope: '*',
      client_id: userCredentials.client_id || process.env.VUE_APP_CLIENTID,
      client_secret: userCredentials.client_secret || process.env.VUE_APP_CLIENTSECRET,
    };

    return new Promise((resolve, reject) => {
      userService.loginUser(userObject)
        .then((response) => {
          const authUser = {};
          authUser.access_token = response.access_token;
          authUser.refresh_token = response.refresh_token;
          authUser.expires_at = new Date(new Date().setSeconds(new Date().getSeconds() + response.expires_in));
          userService.setToken(response.access_token);
          userService.getUser().then((response) => {
            authUser.name = response.data.name;
            authUser.id = response.data.id;
            authUser.email = response.data.email;
            authUser.languageId = response.data.languageId;
            authUser.permissions = response.data.permissions;
            authUser.regions = response.data.regions;
            authUser.needsToChangePassword = response.data.needsToChangePassword;
            return resolve(authUser);
          })
        })
        .catch((error) => {
          console.warn(error);
          return reject(error);
        });
    })
  },

  clearAuthUser: (context) => {
    window.localStorage.removeItem(process.env.VUE_APP_LOCALSTORAGETAG);
    context.commit('CLEAR_USER');
  },

  clearUsers: (context) => {
    context.commit('CLEAR_USERS');
  },

  setLoggedInAtProperty: () => new Promise((resolve, reject) => {
    userService.setLoggedInAtProperty()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  setUserObject: (context, userObj) => {
    context.commit('SET_USER', userObj);
    context.commit('SET_LANGUAGE', userObj.languageId);
  },
};

export default {
  state, mutations, getters, actions,
};
